import { c as _c } from "react/compiler-runtime";
import Text from '@/app/cc/_component/ui/common/Text/Text';
import styles from '@/app/cc/_component/ui/section/CustomerReview/CustomerReview.module.scss';
export default function ReviewCard(t0) {
  const $ = _c(8);
  const {
    review
  } = t0;
  let t1;
  if ($[0] !== review.writer) {
    t1 = <Text as="p" category="heading" variant="sb3" color="var(--color-gray-400)">{review.writer}</Text>;
    $[0] = review.writer;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      whiteSpace: "pre"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== review.content) {
    t3 = <Text as="p" category="heading" variant="m1" color="var(--color-gray-700)" style={t2}>{review.content}</Text>;
    $[3] = review.content;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <div className={styles.ReviewCard}>{t1}{t3}</div>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}